<template>
  <div
    @mouseover="hover = true"
    @mouseleave="hover = false"
    class="option-row relative border border-solid border-transparent rounded-lg"
    @click="$emit('click', row.id)"
    :class="[{ 'border-gray-300 border-dotted': hover }]"
    :style="{ margin: margin }"
  >
    <div
      v-show="hover"
      class="row-handle z-10"
      ref="trigger"
      @mouseover="myhandle_hover = true"
      @mouseleave="myhandle_hover = false"
      v-tooltip="{
        trigger: 'manual',
        show: myhandle_hover,
        content: '<b>Drag</b> to move row<br />',
      }"
    >
      <span class="material-icons text-gray-400 hover:text-blue-500">
        drag_indicator
      </span>
    </div>

    <div class="m-auto relative" :style="{ 'max-width': containerWidth }">
      <draggable
        v-model="options"
        handle=".my-handle"
        draggable=".draggable"
        :key="row.id"
      >
        <transition-group
          v-if="row.type == 'TEXT'"
          name="list"
          tag="div"
          class="flex flex-wrap justify-center m-auto"
          :key="row.id"
          id="option_list"
          :style="{ 'max-width': '910px' }"
        >
          <text-option
            :key="option.id"
            v-for="option in options"
            :option="option"
            :survey="survey"
            :step="step"
            v-on:remove-option="removeOption"
            v-on:clone-option="cloneOption"
            v-on:open-modal="$emit('open-modal')"
            class="draggable"
          ></text-option>
        </transition-group>

        <transition-group
          v-else
          name="list"
          tag="div"
          class="flex flex-wrap justify-center"
          :key="row.id"
          id="option_list"
        >
          <image-option
            :key="option.id"
            v-for="option in options"
            :option="option"
            :survey="survey"
            :step="step"
            v-on:remove-option="removeOption"
            v-on:clone-option="cloneOption"
            v-on:open-modal="showImageModal = true"
            class="draggable"
          ></image-option>
        </transition-group>
      </draggable>
    </div>

    <div @click="addOption">
      <svg-icon
        icon="heroicons/outline/plus-circle"
        class="plus-icon right mx-auto my-auto cursor-pointer text-gray-400 hover:text-blue-500"
        v-tooltip="'Add new choice'"
      />
    </div>
    <!-- End Options -->
  </div>
</template>

<script>
/* eslint-disable vue/no-unused-components */
import Row from "@/models/content/Row";
import Column from "@/models/content/Column";
import Option from "@/models/Option";
import Draggable from "vuedraggable";
import ImageOption from "@/components/Builder/ImageOption.vue";
import TextOption from "@/components/Builder/TextOption.vue";
import Content from "@/models/content/Content";

export default {
  name: "option-row",
  components: {
    Draggable,
    ImageOption,
    TextOption,
    Content,
  },
  data() {
    return {
      hover: false,
      loaded: false,
      showMarginPopover: false,
      bubbleMenu: null,
      myhandle_hover: false,
      horizontalDragActive: false,
    };
  },
  props: ["row_id", "survey", "step", "dragActive", "selected"],
  computed: {
    containerWidth() {
      let max_width = 1100;
      return this.step.containerWidth(this.step.options.length, max_width);
    },
    showImageModal: {
      get() {
        return this.$store.state.modalOpen;
      },
      set(boolean) {
        this.$store.commit("SET_MODAL_STATE", boolean);
      },
    },
    row() {
      return Row.query()
        .whereId(this.row_id)
        .with("columns", (query) => {
          query.orderBy("order", "asc");
        })
        .first();
    },
    options: {
      get() {
        return this.step.options;
      },
      set(options) {
        var reorderedList = Option.reIndexList(options);

        Option.update({
          data: reorderedList,
        });
      },
    },
    width: {
      get() {
        return this.row.width || "auto";
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { width: value },
        });
      },
    },
    height: {
      get() {
        return this.row.height || "auto";
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { height: value },
        });
      },
    },
    top: {
      get() {
        return this.row.top;
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { top: value },
        });
      },
    },
    left: {
      get() {
        return this.row.left;
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { left: value },
        });
      },
    },
    marginTop: {
      get() {
        return this.row.marginTop;
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { marginTop: value },
        });
      },
    },
    marginBottom: {
      get() {
        return this.row.marginBottom;
      },
      set(value) {
        Row.update({
          where: this.row.id,
          data: { marginBottom: value },
        });
      },
    },
    margin() {
      return `${this.marginTop}px 0 ${this.marginBottom}px 0`;
    },
  },
  methods: {
    async addOption() {
      var optionData = Option.seed(this.step.id);

      if (this.row.type == "TEXT") {
        //optionData.title = "Hello new option";
        optionData.contents = [
          {
            parent_type: "option",
            type: "TEXT",
            text: "<strong>Hello new option</strong>",
            fontSize: 18,
          },
        ];
      } else if (this.row.type == "IMAGE") {
        (optionData.image = "undraw/undraw_Post_re_mtr4"),
          (optionData.contents = [
            {
              parent_type: "option",
              type: "TEXT", //content type is TEXT
              text: "<strong>A newwww option title</strong>",
              fontSize: 18,
            },
            {
              parent_type: "option",
              type: "TEXT",
              text: "A new subtitle",
              fontSize: 16,
              fontColor: "#465157",
            },
          ]);
      }

      Option.insert({
        data: optionData,
      });

      //Option.api().post("/api/option/store", optionData);
    },
    async removeOption(option) {
      var result = await Option.api().delete("/api/option/delete/" + option.id);

      if (result.response.status == 200) {
        //Delete step from entities state
        option.$delete();
      } else {
        //Delete failed
        this.$store.dispatch("notification/add", {
          message: "An error occured deleting option",
        });
      }
    },
    cloneOption(option) {
      let optionClone = Option.clone(option);

      Option.insert({
        data: optionClone,
      });
    },
    onDragStart: function(evt) {
      this.$store.commit("SET_DRAG_STATE", true);
      //this.dragActive = true;
    },
    onDragEnd: function(evt) {
      this.$store.commit("SET_DRAG_STATE", false);
      //this.dragActive = false;
    },

    closeBubble() {
      //Close BubbleMenus generated by TipTap editor (uses Tippy.js under the hood)
      const editors = document.querySelectorAll(".ProseMirror");
      editors.forEach((editor) => {
        const tippy = editor._tippy;
        tippy?.hide();
      });
    },

    async deleteRow() {
      console.log("continue deleting row");
      let row = this.row;
      row.columns.forEach((column) => {
        column.contents.forEach((content) => {
          Content.delete(content.id);
        });
        Column.delete(column.id);
      });
      row.$delete();
    },
  },
  mounted() {
    this.loaded = true;

    /*
    let trigger = this.$refs.trigger;
    let menu = this.$refs.menu;

    this.bubbleMenu = tippy(trigger, {
      content: menu,
      interactive: true,
      duration: 100,
      maxWidth: "none",
      hideOnClick: true,
      trigger: "click",
      onClickOutside(instance, event) {
        instance.hide();
        //console.log(instance);
      },
    });
*/
  },
};
</script>

<style lang="scss"></style>
